<template>
  <div>
    <div class="panel">
      <div class="filter">
        <el-form
          :inline="true"
          @submit.native.prevent
          :model="filter"
          ref="filterForm"
          label-position="right"
          label-width="80px"
          class="oneline"
          size="small"
        >
          <el-form-item label="库存基地">
            <BaseSelect v-model="filter.base_id" :clearable="true"></BaseSelect>
          </el-form-item>
          <el-form-item label="钻井" v-if="category == 2">
            <DrillWellSelect
              v-model="filter.drill_well_id"
              :clearable="true"
            ></DrillWellSelect>
          </el-form-item>
          <el-form-item label="库存状态" v-if="category == 2">
            <el-select v-model="filter.status">
              <el-option label="所有" :value="0"></el-option>
              <el-option label="在库" :value="1"></el-option>
              <el-option label="出库待接收" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="成品分类">
            <TemplateMultipleSelect
              style="width: 300px"
              v-model="filter.product_template_ids"
              :category="category"
              :collapseTags="true"
              :all="true"
            ></TemplateMultipleSelect>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="small"
              @click="
                filter.page = 1
                getData()
              "
              >筛选</el-button
            >
            <el-button size="small" @click="reset()">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="panel">
      <div style="display: flex; justify-content: end">
        <file-button
          obj="product_inventory"
          class="m-r-5"
          :filter="queryData"
          :importButton="false"
          exportBtnName="导出明细表"
        ></file-button>
        <file-button
          obj="product_inventory_summary"
          :filter="queryData"
          :importButton="false"
          exportBtnName="导出汇总表"
        ></file-button>
      </div>
      <InventoryTable
        :items="items.list"
        :category="category"
        :status="status"
        v-loading="loading"
      ></InventoryTable>
      <el-pagination
        class="mt-20"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        @current-change="getData"
        layout="total, prev, pager, next"
        :total="items.count"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { productInventoryList } from '@/service/getData'
import InventoryTable from './table'
import TemplateMultipleSelect from '@/components/select/product_template_multiple_select'

export default {
  props: {
    category: {
      type: Number,
      default: 0,
    },
  },
  components: {
    InventoryTable,
    TemplateMultipleSelect,
  },
  computed: {
    queryData() {
      let data = this.clone(this.filter)
      if (data.product_template_ids.length > 0) {
        data.product_template_ids = data.product_template_ids.join(
          '&product_template_ids=',
        )
      } else {
        delete data.product_template_ids
      }
      data.category = this.category
      data.page -= 1
      return data
    },
  },
  data() {
    return {
      loading: false,
      filter: {
        product_template_ids: [],
        base_id: 0,
        drill_well_id: 0,
        page: 1,
        size: 10,
        status: 0,
      },
      items: {
        list: [],
        count: 0,
      },
      status: 0,
    }
  },
  created() {
    if (this.$route.query.filter) {
      this.filter = JSON.parse(this.$route.query.filter)
    }
    this.getData()
  },
  methods: {
    reset() {
      this.$refs['filterForm'].resetFields()
      this.filter.page = 1
      this.filter.product_template_ids = []
      this.filter.base_id = 0
      this.filter.drill_well_id = 0
      this.filter.status = 0
      this.getData()
    },
    async getData() {
      this.$router.replace({
        query: { filter: JSON.stringify(this.filter) },
      })

      this.loading = true
      let res = await productInventoryList(this.queryData)
      if (res.status != 0) return false
      this.items = res.data
      this.status = this.filter.status
      this.loading = false
    },
  },
}
</script>